export interface ApplicationFeatureFlagsDTO {
  battlesEnabled: boolean;
}

export class ApplicationFeatureFlags {
  private _battlesEnabled: boolean;

  static create(
    applicationFeatureFlagsDTO: ApplicationFeatureFlagsDTO
  ): ApplicationFeatureFlags {
    return new ApplicationFeatureFlags(applicationFeatureFlagsDTO);
  }

  constructor(application: ApplicationFeatureFlagsDTO) {
    this._battlesEnabled = application.battlesEnabled;
  }
  public get battlesEnabled() {
    return this._battlesEnabled;
  }
}
